import type { APIReportFilters, ArdoqId } from '@ardoq/api-types';
import { AppModules } from 'appContainer/types';
import { jsonParam, param } from 'router/declarative/paramRegistry';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { i18nTitle } from 'router/declarative/i18nTitle';
import { presentationParamDeclarations } from 'router/presentation/presentationParamDeclarations';

const readerState = param<ArdoqId>({
  fromString: value => value,
  toString: value => value,
});

const reportFilters = jsonParam<APIReportFilters>();

export const routes = {
  path: '/report',
  appModule: AppModules.REPORTS,
  children: [
    {
      path: { index: true },
      title: i18nTitle('report:navigation.overviewTitle', 'Report Overview'),
      content: async (): IndexRouteContent =>
        (await import('../ReportOverview/ReportOverview')).ReportOverview,
    },
    {
      path: '/builder',
      title: i18nTitle('report:navigation.builderTitle', 'Report Builder'),
      content: async (): PathRouteContent =>
        (await import('../ReportBuilder/ReportBuilderContainer'))
          .ReportBuilderContainer,
      children: [
        {
          path: '/:reportId',
        },
      ],
    },
    {
      path: '/reader',
      title: i18nTitle('report:navigation.readerTitle', 'Report Reader'),
      searchParams: { filters: reportFilters, state: readerState },
      children: [
        {
          path: '/:reportId',
          searchParams: presentationParamDeclarations,
          content: async (): PathRouteContent =>
            (await import('../ReportReader/ReportReaderContainer'))
              .ReportReaderContainer,
        },
      ],
    },
  ],
} as const satisfies RouteNode;
